/**
 * @author Mark Limm
 * @desc component that displays a single checkbox option, 
 * which may contain child checkbox options of its own
 * @example <checkbox-option
              ng-repeat="item in $ctrl.categoryList"
              item="item"
              children="item.children"
              checkbox-clicked="$ctrl.categoryClicked({ item })"
              distributor-clicked="$ctrl.distributorClicked({ item })"
              filter-set="$ctrl.filterSet"
              show-one="$ctrl.showOne({ item, type })"
            />
*/
import template from './checkboxOption.html';

class CheckboxOptionController {
  constructor($uibModal, $log, $translate) {
    this.$uibModal = $uibModal;
    this.$log = $log;
    this.$translate = $translate;

    this.isExpanded = false;
    this.hasChildren = false;

    this.activeDistributors = [];
    this.inactiveDistributors = [];
  }

  $onInit() {
    if (this.children) {
      this.hasChildren = this.children && this.children.length;

      this.sortDistributors();
    }
  }

  $onChanges(changesObj) {
    if (changesObj.children && changesObj.children.currentValue) {
      this.sortDistributors();
    }
  }

  hasActiveChild() {
    return this.activeDistributors.length > 0;
  }

  sortDistributors() {
    this.activeDistributors = this.children.filter(c => c.active);
    this.inactiveDistributors = this.children.filter(c => !c.active);
  }

  toggleChildOptionsDisplay() {
    this.isExpanded = !this.isExpanded;
  }

  viewAllClicked() {
    const searchOptions = this.children;
    const selectedOptions = this.activeDistributors;

    const category = this.item;
    const searchPlaceholder = this.$translate.instant('DISTRIBUTOR.SEARCH', { category: this.item.name });

    const modalInstance = this.$uibModal.open({
      component: 'listSelectorDialog',
      windowClass: 'list-selector-dialog-container',
      resolve: {
        parentOption: () => category,
        searchOptions: () => searchOptions,
        searchPlaceholder: () => searchPlaceholder,
        selectedOptions: () => selectedOptions
      }
    });

    modalInstance.result.then(
      (result) => {
        if (!result) return;

        const { parentOption, selectedChildren } = result;

        if (!Array.isArray(selectedChildren)) return;

        this.distributorsSelected({
          category: parentOption,
          selectedDistributors: selectedChildren
        });
      },
      (error) => {
        this.$log.error(error);
      });
  }
}

CheckboxOptionController.$inject = ['$uibModal', '$log', '$translate'];

const checkboxOption = {
  controller: CheckboxOptionController,
  template,
  bindings: {
    item: '<',
    children: '<',
    checkboxClicked: '&',
    distributorClicked: '&',
    distributorsSelected: '&',
    filterSet: '<',
    showOne: '&'
  }
};

export default function (ngModule) {
  ngModule.component('checkboxOption', checkboxOption);
  ngModule.controller('checkboxOptionController', CheckboxOptionController);
}
